/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Custom hook to enable drag-and-drop touch for quick schedule review step
 * @author Satyaki Bose
 *
 * @file useScheduleDragDropTouch.js
 */

import { useEffect } from 'react';
import { enableDragDropTouch } from '@dragdroptouch/drag-drop-touch';

/**
 * Custom hook to enable drag-and-drop touch for the schedule component.
 */
const useScheduleDragDropTouch = (rootRef) => {
  useEffect(() => {
    const root = rootRef.current;
    if (!root) {
      return;
    }

    enableDragDropTouch(root, root, {
      allowDragScroll: true,
      dragThresholdPixels: 8
    });
  }, [rootRef]);
};

export default useScheduleDragDropTouch;
